const constants = {
  defaultRowWidth: 200,
  defaultRowHeight: 40
}

export default constants;
